export default "__VITE_ASSET__ua7Kuz1c__"